<template>
  <div class="user-agreement-box">
      <title-nav :title="'用户协议'"/>
      <div class="text" v-for="(item, i) in privacyPolicy" :key="i">
        <div class="title" v-show="item.title.length > 0">{{ item.title }}</div>
        <div class="content" v-show="item.content.length > 0">{{  item.content  }}</div>
      </div>
  </div>
</template>

<script>
import TitleNav from '../../components/nav/TitleNav.vue'

export default {
name: 'UserAgreement',
components: {
  TitleNav,
},
mounted(){
},
data:()=>{
  return {
    privacyPolicy:[{
      title:'',
      content:'用户协议'
    },{
      title:'',
      content:'版本更新日期：2024年11月29日'
    },{
      title:'',
      content:'版本生效日期：2024年12月31日'
    },{
      title:'',
      content:'本用户协议将向您说明以下内容：'
    },{
      title:'',
      content:'一、注册与账户管理'
    },{
      title:'',
      content:'二、用户行为规范'
    },{
      title:'',
      content:'三、知识产权等权益'
    },{
      title:'',
      content:'四、不可抗力和免责事由'
    },{
      title:'',
      content:'五、违约责任'
    },{
      title:'',
      content:'六、通知和广告'
    },{
      title:'',
      content:'七、协议的终止'
    },{
      title:'',
      content:'八、法律适用、管辖'
    },{
      title:'',
      content:'九、其他条款'
    },{
      title:'',
      content:'十、联系方式'
    },{
      title:'一、注册与账户管理',
      content:'用户在注册程序开始前，应具备中华人民共和国法律规定的与行为相适应的民事行为能力。若不具备相应民事行为能力，用户及其监护人应依照法律规定承担一切后果。'
    },{
      title:'',
      content:'用户可以通过登录本平台的用户账号注册页面注册用户账号并设置相应的登录密码。一经注册成功，用户即可凭借用户账号及登录密码登录及使用本平台。目前，用户账号为移动电话号码。'
    },{
      title:'',
      content:'用户成功注册后，如需使用该用户账号从本平台购买商品，至少需要填写一个收货人、收货地址和手机号码。此外，用户还可以按照本平台相关页面的说明填写用户姓名、移动电话、固定电话、所在地地址等个人信息。这些信息仅用于完善用户账号资料，不影响用户从本平台购买商品。'
    },{
      title:'',
      content:'绿锋1688平台只允许每位用户使用一个账户。如有证据证明或绿锋1688根据平台规则判断用户存在不当注册或不当使用多个账户的情形，绿锋1688平台可以采取冻结或关闭账户、取消订单、拒绝提供服务等措施。如给绿锋1688平台及相关方造成损失的，用户还应承担赔偿责任。'
    },{
      title:'',
      content:'用户务必妥善保管自己的用户账号、登录密码、支付密码（如有）及在其项下填写的所有个人信息。因用户主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，本平台不承担责任。用户应通过司法、行政等救济途径向侵权行为人追偿。除本平台存在过错外，用户应对其账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。'
    },{
      title:'',
      content:'为了防止用户账号及其项下的个人信息泄露或被他人窃取，绿锋1688可能会随时采取计算机病毒查杀技术、计算机加密技术等措施进行保护。对此，用户完全同意并接受，但这并不能免除用户对账号及其项下的个人信息所负有的妥善保管义务。'
    },{
      title:'',
      content:'由于绿锋1688平台账户关联用户的个人信息及平台商业信息，用户的绿锋1688平台账户仅限本人使用。仅当有法律明文规定、司法裁定或经本平台同意时，用户方能进行账户的转让。用户的账户一经转让，该账户项下的权利义务一并转移。除此外，用户的账户不得以任何方式转让，否则本平台有权追究用户的违约责任，由此产生的一切责任由用户承担。'
    },{
      title:'',
      content:'如果用户遗忘了密码或者密码被他人修改，用户可以按照绿锋1688公布的账号及密码找回规则，通过绿锋1688提供的账号及密码找回系统程序进行找回，或者在第一时间联系绿锋1688的客服人员协助找回，但绿锋1688不保证一定可以找回。'
    },{
      title:'',
      content:'本平台为用户提供账户注销功能，用户可以按照《绿锋1688隐私政策》的指引注销个人账户。注销账户后，除依法应当予以继续保存的部分外，用户的相关个人信息将被删除或进行匿名化处理。'
    },{
      title:'',
      content:'如果用户的账户同时符合以下条件，则绿锋1688可回收用户的账户，用户的账户将不能再登录任一绿锋1688平台，相应服务同时终止：(1)未绑定通过实名认证的绿锋1688账户；(2)连续六个月未用于登录任一绿锋1688平台；(3)不存在未到期的有效业务。'
    },{
      title:'',
      content:'当用户不再使用绑定绿锋1688账户的手机号码时，应当及时对账户手机号进行变更。因用户未及时变更手机号导致账号内信息或财产安全出现风险将由用户自行承担全部责任。当我们在有限能力范围内识别到用户的账户内财产或信息存在安全风险时，我们有权对用户的账户进行处置（包括但不限于解除手机号绑定、冻结、停用或者注销账户）。'
    },{
      title:'二、用户行为规范',
      content:'（一）用户同意严格遵守以下义务'
    },{
      title:'',
      content:'a.不得传输或发表:违反中华人民共和国宪法及其他法律规定的言论，煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论;'
    },{
      title:'',
      content:'b.不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料;'
    },{
      title:'',
      content:'c.不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论;'
    },{
      title:'',
      content:'d.不得发布任何侵犯他人人格权、名誉权、肖像权、著作权、商标权等知识产权或合法权利的内容，或其他在本网站中使用可能视为被禁止或可能被禁止的任何内容;'
    },{
      title:'',
      content:'e.不得利用本网站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动;'
    },{
      title:'',
      content:'f.不得干扰本网站的正常运转，不得侵入本网站及国家计算机信息系统;'
    },{
      title:'',
      content:'g.不得在未经本网站事先明示书面准许时，对本网站的任何内容(除您的个人信息以外)制作拷贝、进行复制、修改、制作衍生作品、分发或公开展示等的侵权行为;'
    },{
      title:'',
      content:'h.不得教唆他人从事本条所禁止的行为;'
    },{
      title:'',
      content:'i.不得有其他违法违规、侵犯他人合法权益、干扰我们正常运营的行为。'
    },{
      title:'',
      content:'j.不得有其他违反本协议的行为。'
    },{
      title:'',
      content:'（二）我们可依据用户操作数据/记录来认定用户是否违反第3.1条，并有权采取如下一项或多项措施'
    },{
      title:'',
      content:'a.删除、屏蔽、断开链接;'
    },{
      title:'',
      content:'b.限制参加营销活动;'
    },{
      title:'',
      content:'c.中止向用户提供服务;'
    },{
      title:'',
      content:'d.注销/冻结用户账户，终止向用户提供服务;'
    },{
      title:'',
      content:'e.追究法律责任;'
    },{
      title:'',
      content:'f.其他合法的限制、追偿、处理措施。'
    },{
      title:'',
      content:'（三）因用户违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，以及因用户行为导致我们或本网站遭受行政处罚或承担侵权损害赔偿责任的，用户应当独立承担责任;我们或任何第三方因此遭受损失的，用户也应当一并赔偿全部损失，包括但不限于律师费、诉讼费、保全担保费、差旅费等维权成本，'
    },{
      title:'三、知识产权等权益',
      content:'（一）平台内容所有权'
    },{
      title:'',
      content:'“绿锋1688”对本平台的内容享有全部知识产权，包括但不限于编码、商标、服务标志、商号、图形、美术品、照片、肖像、文字内容、音频片断、按钮图标、购买评价以及计算机软件、标识、数码下载、数据汇编等。这些内容均为“绿锋1688”或其内容提供者的财产，受到中华人民共和国知识产权相关法律法规的保护。'
    },{
      title:'',
      content:'（二）用户使用限制'
    },{
      title:'',
      content:'您仅在符合本平台使用目的的前提下被许可浏览和使用本平台，即以个人名义浏览信息和购买供个人使用商品的目的。其他方式的使用都是被严格禁止的，包括但不限于以下方式：复制、修改、销售、传送、再版、删除、添加、展览、记入或演示本平台的内容或以其他方式部分地或整体地非法使用本平台的内容，但经“绿锋1688”允许将本平台当中的资讯转发至微信朋友圈等第三方媒体的除外。'
    },{
      title:'',
      content:'（三）法律责任'
    },{
      title:'',
      content:'非经我们明示书面同意，任何主体均不得擅自下载、复制、传输、修改、编辑制作等操作本网站及本网站所提供的服务的相关著作权、商标使用权、商业隐私及其他任何信息内容，否则将承担所有法律责任。'
    },{
      title:'',
      content:'（四）用户内容责任'
    },{
      title:'',
      content:'您应确保在本网站上发表的各类信息内容均不涉及侵犯第三方肖像、隐私、知识产权或其他合法权益。否则我们有权随时采取包括但不限于删除、屏蔽、断开链接等措施。'
    },{
      title:'',
      content:'（五）特别许可'
    },{
      title:'',
      content:'除法律另有强制性规定外，未经我们明确的特别书面许可，任何主体不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本网站的信息内容，否则，我们有权追究其法律责任。'
    },{
      title:'',
      content:'（六）资料信息保护'
    },{
      title:'',
      content:'本网站所刊登的资料信息（诸如文字、图表、标识、图像、声音文件片段、数字下载、数据编辑等），均是我们或相关内容提供者的财产，受著作权法保护。本网站上所有内容的汇编是我们的排他财产，受著作权法保护。'
    },{
      title:'四、不可抗力和免责事由',
      content:'（一）不可抗力定义'
    },{
      title:'',
      content:'本协议中规定的不可抗力包括：地震、台风、洪水等自然灾害；战争、罢工、停电、政府行为；电信线路被人为破坏或非“绿锋1688”的线路、设备因故障、调试、扩容所引起的中断；黑客攻击、网络备案等；政府管理部门提出要求“绿锋1688”暂停或终止提供相应服务等非“绿锋1688”原因。'
    },{
      title:'',
      content:'（二）不可抗力影响'
    },{
      title:'',
      content:'当由于上述不可抗力原因使合约无法履行的，双方应立即协商解决问题的方案。如果不可抗力持续十五(15)日以上，且导致本协议无法继续履行的，则任一方均可书面通知终止本协议，“绿锋1688”有权不退还已收取款项。'
    },{
      title:'',
      content:'（三）免责声明'
    },{
      title:'',
      content:'“绿锋1688”与其他的在线使用的互联网网站一样，也会受到各种不良信息、网络安全和网络故障问题的困扰。包括但不限于其他用户可能会发布诈骗或虚假信息，或者发表有谩骂、诅咒、诋毁、攻击内容的，或者含有淫秽、色情、下流、反动、煽动民族仇恨等让人反感、厌恶的内容的非法言论；其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私权和/或其他合法权益的图片、照片、文字等资料；面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。'
    },{
      title:'',
      content:'（四）商品销售免责声明'
    },{
      title:'',
      content:'a.由于用不同手机终端设备观看时页面显示的差异，“绿锋1688”上促销的商品在图像和颜色方面可能跟真实的物品不尽一致。因此，所有显示的图片、视频和其他商品显示方法仅限于图示目的，在任何情况下不认为是合同的组成部分。假如供出售的商品跟网站上的描述不同，对您唯一的补救措施是根据本协议在没有使用的情况下退回该商品。'
    },{
      title:'',
      content:'b.销售商保留根据市场价格波动随时修改上线商品价格的权利而无须事先通知您。在由于排版错误或销售商提供价格信息错误的情况下以不正确的价格列出来的商品，如果造成了重大误解，销售商有拒绝或取消任何对以不正确的价格列出来的商品所下订单的权利。'
    },{
      title:'',
      content:'c.由于合理的或不可避免的送货延迟对您或第三方带来的任何损失，“绿锋1688”不负任何责任。在这种情况下，“绿锋1688”将尽快地把任何可预知的延迟情况通知您，并在此时请您选择是否取消订单。'
    },{
      title:'',
      content:'d.“绿锋1688”上面陈列的货物完全符合中华人民共和国的相关法律法规的规定。“绿锋1688”直接与销售商合作，他们保证其商品是正宗的。您在本平台上找到的所有商品及商品描述均由销售商提供，仅由他们对其真实性负责。您应该系统性地参照货物描述找出他们的特征，对于任何种类的直接或间接的、实质或非实质的由于商品的使用造成的损失，“绿锋1688”概不负责。'
    },{
      title:'',
      content:'五、违约责任'
    },{
      title:'',
      content:'（一）违约责任承担'
    },{
      title:'',
      content:'服务条款任何一方违约需依法承担违约责任。绿锋1688不承担因不可抗力、计算机病毒、黑客攻击等因素导致的服务中断或用户损失。'
    },{
      title:'',
      content:'（二）非控制范围内免责'
    },{
      title:'',
      content:'由于用户故意或过失导致的损失，绿锋1688不承担任何责任。包括但不限于用户操作失误、数据丢失等情形。'
    },{
      title:'',
      content:'（三）赔偿金限额'
    },{
      title:'',
      content:'如果因绿锋1688原因造成用户损失，赔偿金的上限为有关绿锋1688服务最近一次续费时实际支付的绿锋1688服务费总额。客户未续费的，以首次支付的服务费为限。'
    },{
      title:'',
      content:'（四）部分条款无效处理'
    },{
      title:'',
      content:'本服务条款所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本服务条款涵义解释的依据。'
    },{
      title:'',
      content:'（五）条款解释权'
    },{
      title:'',
      content:'本服务条款最终解释权归“绿锋1688”所有。如有任何争议，双方应友好协商解决，协商不成的，提交法院诉讼解决。'
    },{
      title:'六、商品描述和营销通知',
      content:'（一）商品描述'
    },{
      title:'',
      content:'除非销售商或本平台另有说明，销售商出售的商品均为正宗的商品。绿锋1688直接与销售商合作开展各项营销活动，相关商品信息均由销售商提供，绿锋1688尽可能根据所接收到的商品信息准确、详尽地描述每一件商品。然而，由于销售商所提供的商品不一定是准确、完整、可靠、有效和没有错误的，因此绿锋1688不能保证本平台所有商品的描述和其他相关内容是准确、完整、可靠、有效和没有错误的。'
    },{
      title:'',
      content:'（二）营销通知'
    },{
      title:'',
      content:'您一经注册用户账号，即视为您同意绿锋1688及/或其关联公司通过短信或者电子邮件、语音外呼等方式向您注册时填写的手机号码或者电子邮箱发送相应的商品广告信息、促销优惠等营销信息；您如果不同意发送，您可以通过相应的退订功能进行退订。'
    },{
      title:'七、协议的终止',
      content:'（一）服务期限与终止'
    },{
      title:'',
      content:'若您已与“绿锋1688”签订《绿锋1688服务销售合同》，则服务期限以该合同约定为准。若未签订合同，则服务期限自您成功创建绿锋1688服务之日起计算，并以您所缴纳的服务费款项数额为依据确认服务期限。'
    },{
      title:'',
      content:'（二）合同提前终止条件'
    },{
      title:'',
      content:'a.双方协商一致同意提前终止合同。'
    },{
      title:'',
      content:'b.不可抗力豁免：'
    },{
      title:'',
      content:'本协议中规定的不可抗力包括：地震、台风、洪水等自然灾害；战争、罢工、停电、政府行为；电信线路被人为破坏或非“绿锋1688”的线路、设备因故障、调试、扩容所引起的中断；黑客攻击、网络备案等；政府管理部门要求“绿锋1688”暂停或终止提供相应服务的非“绿锋1688”原因。当由于上述不可抗力原因使合约无法履行时，双方应立即协商解决问题的方案。如果不可抗力持续十五(15)日以上，且导致本协议无法继续履行的，则任一方均可书面通知终止本协议，“绿锋1688”有权不退还已收取款项。'
    },{
      title:'',
      content:'（三）部分条款无效处理'
    },{
      title:'',
      content:'本服务条款所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本服务条款涵义解释的依据。'
    },{
      title:'',
      content:'（四）最终解释权'
    },{
      title:'',
      content:'本服务条款最终解释权归“绿锋1688”所有。如有任何争议，双方应友好协商解决，协商不成的，提交法院诉讼解决。'
    },{
      title:'八、法律适用、管辖',
      content:'（一）法律适用：本协议的成立、生效、履行、解释及纠纷解决均适用中华人民共和国大陆地区的法律（不包括冲突法）。'
    },{
      title:'',
      content:'（二）签订地点：本协议的签订地为中华人民共和国深圳市南山区。'
    },{
      title:'',
      content:'（三）争议解决：若您与本网站之间发生任何纠纷或争议，应首先通过友好协商的方式解决。如果协商未能达成一致意见，您同意将该纠纷或争议提交至本协议签订地（即中国深圳市南山区）具有管辖权的人民法院进行裁决。'
    },{
      title:'',
      content:'（四）条款标题说明：本协议中所有条款的标题仅为方便阅读而设，并不构成对条款内容的解释依据。'
    },{
      title:'',
      content:'（五）部分无效条款处理：即使本协议中的某一条或多条条款因任何原因被判定为无效或不可执行，这不影响其他条款的有效性和可执行性。其余有效条款继续对双方产生约束力。'
    },{
      title:'九、其他条款',
      content:''
    },{
      title:'',
      content:'绿锋1688对以上条款保有最终解释权。绿锋1688保留随时修订本协议的权利，并通过适当方式公开征求意见。您应关注并了解修订情况，如不同意修订后协议版本，请立即停止使用本平台。绿锋1688可能通过消费者告知书、买家须知等形式说明您在使用本平台购买商品时应履行的其他义务，您应仔细阅读并全面履行。如有冲突，以上述说明为准。标题仅为提示作用，无解释及适用指引。购买非商品服务产品时，权利义务参照本协议。隐私权政策、平台规则为补充协议，具有同等法律效力。双方应严格履行义务，争议可协商或诉讼解决。'
    },{
      title:'十、联系方式',
      content:'客服电话：020-36331287'
    }]
  }
},
methods:{
},
}
</script>

<style scoped lang="scss">
.user-agreement-box {
  min-height: 100vh;
  background: #fafafa;
  padding: 60px 15px 0;
  color: #222;
  .text {
    text-align: left;
    padding-bottom: 0px;
    word-break: break-all;
    .title {
      font-size: 18px;
      padding: 15px 0;
    }
    .content {
      padding: 10px 0;
    }
  }
}
</style>